import { Placeholder } from '../components/Placeholder.jsx';

export function NotFound() {
  return <Placeholder titre="Page introuvable" description="Cette adresse ne correspond à aucun écran." />;
}
